import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Plus, Edit, Trash, Trash2} from 'react-feather';
import Sidebar from './sidebar';
import React,{ useState,useEffect } from 'react';
import api from "../api";
import { FaTag} from 'react-icons/fa';
function SellerProducts(){    
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;
    const [ProductData, setProductData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOption, setSortOption] = useState("default"); 
    const [DelId, setDelId] = useState("");
    const [DelIdStatus, setDelIdStatus] = useState(false);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [count, setCount] = useState(0);

  
    const token = localStorage.getItem("access_token");
    const fetchVendorProducts = async (pageNumber = 1) => {
        try {
            const response = await api.get(`/vendor-products/?page=${pageNumber}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data?.results) {
                const res = response.data.results;

                setProductData(res.products);
                setCount(response.data.count);
                setPage(pageNumber);

                const pageSize = 100; // SAME AS BACKEND PAGE_SIZE
                setTotalPages(Math.ceil(response.data.count / pageSize));
            }
        } catch (error) {
            //console.error("Error fetching products:", error);
        }
    };

    
    useEffect(() => {
        fetchVendorProducts(1);
    }, []);

    function deleteStepOne(product){
        setDelId(product);
        setDelIdStatus(false);
      }
      function handleDelete(){
          api.delete(baseUrl+'/product/'+DelId+'/', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(function (response){
            //console.log(response.status);
              if(response.status==204){
                  fetchVendorProducts();
                  setDelIdStatus(true);
              }
          })
          .catch(function(error){
              //console.log(error);
          });
      }

    // Filter and Sort Products
    const filteredAndSortedResults = ProductData.filter((product) => {
    const search = searchTerm.toLowerCase();
    return (
        (product.title && product.title.toLowerCase().includes(search)) ||
        (product.price && product.price.toString().toLowerCase().includes(search))
    );
    }).sort((a, b) => {
        const aHasDiscount = a.offer_price > a.price;
        const bHasDiscount = b.offer_price > b.price;

        if (aHasDiscount && !bHasDiscount) return -1;
        if (!aHasDiscount && bHasDiscount) return 1;

        if (sortOption === "price_high_low") return b.price - a.price;
        if (sortOption === "price_low_high") return a.price - b.price;
        if (sortOption === "qty_high_low") return b.stock - a.stock;
        if (sortOption === "qty_low_high") return a.stock - b.stock;
        if (sortOption === "default") return b.id - a.id;
        return 0; // Default sorting (no change)
    });
    
    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };
    return (
        <>                     
            <Helmet>
                <title>Products</title>
                <meta name="description" content={`Products`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max orderscontainer">                        
                            <div className="row mb-3 ph-header-con">
                                <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Products</h6></div>
                                <div className="col-5 pr-0"><Link to="/seller/addproduct"><button className="btn btn-primary f85 float-right br50r"><Plus/> Product</button></Link></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-8">
                                    <input
                                        className="filter2 border me-2 w-100"
                                        type="search"
                                        placeholder="Search Products"
                                        aria-label="Search"
                                        onChange={(e) => setSearchTerm(e.target.value)} // Update the search term on keyup
                                    />
                                </div>
                                <div className="col-4 pr-0">
                                        <select className="filter2 text-center border w-100 h-100" name='category' onChange={(e) => setSortOption(e.target.value)}>
                                            <option value="default">Sort</option>
                                            <option value="price_high_low">Price from High to Low</option>
                                            <option value="price_low_high">Price from Low to High</option>
                                            <option value="qty_high_low">Qty from High to Low</option>
                                            <option value="qty_low_high">Qty from Low to High</option>
                                        </select>
                                </div>
                            </div>

                            <div className="mb-4">
                                    {filteredAndSortedResults.length === 0 ? (
                                        <p>No products found.</p>
                                    ) : (
                                        <>
                                            {filteredAndSortedResults.map((product,index) => (
                                                <div className="row ord-bg bg-white p-2 hvr bx-shadow" key={product.id}>
                                                        <div className="col-3 col-lg-1 p-0"><span className="float-left"></span>
                                                            <div className="ord-img float-left">
                                                            <img src={baseUrl0+product.product_imgs[0].image} className='w-100 h-100'/>       
                                                            </div>
                                                        </div>
                                                        <div className="col-5 col-lg-6 pl-0 pr-0">
                                                            <div className="row">
                                                                <div className="col-11 col-lg-5 ord-sz"><Link to={`/product/${product.title}/${product.id}`}>{product.title}</Link></div>
                                                                <div className="col-8 col-lg-5 ord-sz">

                                                                    {Number(product.offer_price) > Number(product.price) ? (
                                                                        <>
                                                                            <span>{getVendorCurrency()} {Math.round(product.price)} <FaTag className='text-success mb-1 small-icon-11'/></span>
                                                                            <span className='normal_price_cross grey-text_888 font8'></span>
                                                                        </>
                                                                        ) : (
                                                                        <>
                                                                            <span>{getVendorCurrency()} {Math.round(product.price)}</span>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="col-4 col-lg-2 ord-sz grey-text">Qty: {product.stock}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-4 col-lg-4 f8 text-black prodedtbtn text-right p-0 mt-1 lh34">
                                                                <Trash onClick={()=>deleteStepOne(product.id)} className="text-danger border-0 me-2" data-bs-toggle="modal" data-bs-target="#confirmdelModal"/>
                                                                <Link to={`/seller/update-product/${product.id}`}><Edit className="text-dark border-0  ms-2"/></Link>
                                                        </div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                

                            </div>

                            <div className="pagination-container mt-4 text-center">
                                {totalPages > 1 && (
                                    <nav aria-label="Products pagination">
                                        <ul className="pagination justify-content-center">

                                            {/* Prev */}
                                            <li
                                                className={`page-item ${page === 1 ? "disabled" : ""}`}
                                                onClick={() => page > 1 && fetchVendorProducts(page - 1)}
                                            >
                                                <span className="page-link prev-next">← Prev</span>
                                            </li>

                                            {/* Numbers */}
                                            {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((num) => (
                                                <li
                                                    key={num}
                                                    className={`page-item ${page === num ? "active" : ""}`}
                                                    onClick={() => fetchVendorProducts(num)}
                                                >
                                                    <span className="page-link">{num}</span>
                                                </li>
                                            ))}

                                            {/* Next */}
                                            <li
                                                className={`page-item ${page === totalPages ? "disabled" : ""}`}
                                                onClick={() => page < totalPages && fetchVendorProducts(page + 1)}
                                            >
                                                <span className="page-link prev-next">Next →</span>
                                            </li>

                                        </ul>
                                    </nav>
                                )}
                            </div>

                    </div>
                </div>

                <div className="modal fade" id="confirmdelModal" tabIndex="-1" aria-labelledby="confirmdelModalLabel" aria-hidden="true">
                    <div className="modal-dialog mtop_modal">
                        <div className="modal-content">                            
                            <div className="modal-body text-center font9">                                
                                <div className="bg-danger-subtle br50r p-0 text-center text-danger" role="alert" style={{ height: "40px", width: "40px", margin: "0 auto" }}>
                                    <Trash2 className='mt-2'/>
                                </div>
                                <h2 className="modal-title fw800 text-center mt-2" id="confirmdelModalLabel">Delete Product?</h2>
                                {DelIdStatus==true && <>Deleted Successfully</>}
                                {DelIdStatus==false && <>Are you sure you want to delete this product?</>}   

                                <div className='mt-4'>
                                    {DelIdStatus==false && <><button type="button" className="col-12 btn btn-danger" onClick={() => handleDelete()}>Delete</button></>}
                                    <button type="button" className="col-12 btn btn-outline-dark font-bold mt-2" data-bs-dismiss="modal">Close</button>
                                </div>                      
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default SellerProducts;